import decimal from '@bingads-webui-component-legacy/humanize/decimal';
import { validateNumber, getNumberErrorMsg } from '../components/utility';

const lengthOfStayConst = {
  min: 0,
  max: 30,
  isInteger: true,
};

export const validateLengthOfStayDays = ({
  value, min = lengthOfStayConst.min, max = lengthOfStayConst.max, isInteger = lengthOfStayConst.isInteger,
}) => validateNumber({
  value, min, max, isInteger, extra: [],
});
export const getValidateLengthOfStayDaysErrorMsg = ({
  code, i18n, min = lengthOfStayConst.min, max = lengthOfStayConst.max,
}) => {
  switch (code) {
    default:
      return getNumberErrorMsg({
        code, i18n, min, max,
      });
  }
};

export const isLengthOfStayOverlapCal = (dt1, dt2) => {
  const start1 = Number(dt1.minimumNumber);
  const end1 = Number(dt1.maximumNumber);
  const start2 = Number(dt2.minimumNumber);
  const end2 = Number(dt2.maximumNumber);
  let [flag1, flag2, flag3] = [true, true, true];
  if (decimal.isValid(dt1.minimumNumber) && decimal.isValid(dt1.maximumNumber)) {
    flag1 = start1 <= end1;
  }
  if (decimal.isValid(dt2.minimumNumber) && decimal.isValid(dt2.maximumNumber)) {
    flag2 = start2 <= end2;
  }
  if (decimal.isValid(dt1.maximumNumber) && decimal.isValid(dt2.minimumNumber)) {
    flag3 = end1 < start2;
  }
  if (!flag1 || !flag2) {
    return 'minimum_greater_than_maximum_nights';
  }
  if (!flag3) {
    return 'adjust_settings';
  }
  return '';
};
